/* eslint-disable array-callback-return */
import {
    ArrowRightOutlined,
    ArrowLeftOutlined,
    ExclamationCircleOutlined,
} from '@ant-design/icons';
import { Form, Input, Radio, Button, Tooltip } from 'antd';
import classNames from 'classnames';

export default function Stap3(props) {
    const { TextArea } = Input;

    const onNextStep = () => {
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    return (
        <div
            className="rounded-md p-5 h-full"
            style={{
                backgroundColor: props?.customStyle?.bgColor, //bgColor
            }}
        >
            <div className="space-y-3">
                <div
                    className="text-xl font-bold px-3"
                    style={{
                        color: props?.fontStyle?.textCardColor,
                    }}
                >
                    3.{' '}
                    {props.lang === 'TH'
                        ? 'รายละเอียดของการขอใช้สิทธิ'
                        : 'Rights Requested Details'}
                </div>
                <div style={{ border: '1px solid #DBDBDB' }}></div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    name="step3"
                    form={props.form}
                    layout="vertical"
                    className="px-3"
                >
                    <div
                        className="font-bold text-xl pb-3"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'รายละเอียดของการขอใช้สิทธิ'
                            : 'Rights Requested Details'}
                    </div>
                    <div className="font-bold flex items-center space-x-3 pb-1">
                        <div
                            style={{
                                color: props?.fontStyle?.textCardColor,
                                fontSize: props?.fontStyle?.fontSize,
                            }}
                        >
                            {props.lang === 'TH'
                                ? 'ระบุข้อมูลส่วนบุคคลที่ประสงค์จะใช้สิทธิ'
                                : 'Please specify type of Personal data'}
                            <span
                                className="ml-1.5 pb-1 text-[#ff4d4f] font-medium text-sm lead-[1px]"
                                style={{ fontFamily: 'SimSun, sans-serif' }}
                            >
                                *
                            </span>
                        </div>
                        <div>
                            <Tooltip
                                placement="right"
                                overlayClassName="min-w-[30%]"
                                title={
                                    props.lang === 'TH' ? (
                                        <>
                                            ข้อมูลส่วนบุคคลที่ท่านต้องการร้องขอใช้สิทธิ
                                            <br />
                                            เช่น ชื่อ - นามสกุล , เบอร์โทรศัพท์
                                            ฯลฯ
                                        </>
                                    ) : (
                                        <div className="whitespace-pre-line">{`Personal Data that you need exercise rights, such as \nname-surname, telephone number, etc.`}</div>
                                    )
                                }
                            >
                                <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                    <ExclamationCircleOutlined />
                                </a>
                            </Tooltip>
                        </div>
                    </div>
                    <Form.Item
                        hidden={false}
                        rules={[
                            {
                                required: true,
                                message:
                                    props.lang === 'TH'
                                        ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                        : 'This field is required.',
                            },
                        ]}
                        name="dsRequestData"
                    >
                        <TextArea
                            size="large"
                            autoSize={{ minRows: 5 }}
                            placeholder={
                                props.lang === 'TH'
                                    ? 'รายละเอียดอื่น'
                                    : 'Additional details'
                            }
                        />
                    </Form.Item>
                    <div
                        className="font-bold text-xl pb-3"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'รายละเอียดเบื้องต้นเกี่ยวกับผู้ยื่นคำร้อง'
                            : 'Contact details of Requester'}
                    </div>
                    <div
                        className="font-bold flex items-center space-x-3 pb-1"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                            fontSize: props?.fontStyle?.fontSize,
                        }}
                    >
                        <div>
                            {props.lang === 'TH'
                                ? 'ระบุประเภทการขอใช้สิทธิ'
                                : 'Please specify type of Data Subject Rights Request'}
                            <span
                                className="ml-1.5 pb-1 text-[#ff4d4f] font-medium text-sm lead-[1px]"
                                style={{ fontFamily: 'SimSun, sans-serif' }}
                            >
                                *
                            </span>
                        </div>
                        <div>
                            <Tooltip
                                placement="right"
                                overlayClassName="min-w-[30%]"
                                title={
                                    props.lang === 'TH' ? (
                                        <>
                                            กรณีที่เจ้าของข้อมูลพบว่าบริษัทฯ
                                            ประมวลผลข้อมูลส่วนบุคคลของท่าน
                                            โดยไม่ขอความยินยอม
                                            โดยเจ้าของข้อมูลสามารถระบุแหล่งที่มา
                                            ของข้อมูลที่พบเห็นได้ เช่น URL ,
                                            Link ภายใน Web หรือ Application
                                            ของบริษัท
                                        </>
                                    ) : (
                                        'In case that the data owner finds that the company Process your personal data without consent The owner of the data can specify the source of the data that can be seen, such as URL, Link within the Web or the Company Application.'
                                    )
                                }
                            >
                                <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                    <ExclamationCircleOutlined />
                                </a>
                            </Tooltip>
                        </div>
                    </div>
                    <Form.Item
                        name="claimTypeId"
                        rules={[
                            {
                                required: true,
                                message:
                                    props.lang === 'TH'
                                        ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                        : 'This field is required.',
                            },
                        ]}
                    >
                        <Radio.Group className="w-full">
                            <div
                                className={classNames(
                                    'gap-3',
                                    {
                                        'grid grid-cols-2':
                                            props?.platform === 'Desktop',
                                    },
                                    {
                                        'grid grid-cols-2':
                                            props?.platform === 'Tablet',
                                    },
                                    {
                                        'grid grid-cols-1':
                                            props?.platform === 'Mobile',
                                    }
                                )}
                                // className="md:grid sm:grid-cols-1 md:grid-cols-2 gap-3"
                            >
                                {props?.requestTypeList?.map((item) => {
                                    return (
                                        <div key={item?.requestTypeId}>
                                            <Radio
                                                style={{
                                                    color: props?.fontStyle
                                                        ?.textCardColor,
                                                    fontSize:
                                                        props?.fontStyle
                                                            ?.fontSize,
                                                }}
                                                value={item?.requestTypeId}
                                            >
                                                <div className="flex items-center">
                                                    <div>
                                                        {props?.lang === 'EN'
                                                            ? item?.requestTypeNameEn
                                                            : item?.requestTypeShortName}
                                                    </div>
                                                    <Tooltip
                                                        placement="rightTop"
                                                        title={
                                                            <div
                                                                className="whitespace-pre-line"
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        props.lang ===
                                                                        'TH'
                                                                            ? item?.hintTh
                                                                            : item?.hintEn,
                                                                }}
                                                            />
                                                        }
                                                    >
                                                        <span className="text-purple pl-1 pt-[3px]">
                                                            <ExclamationCircleOutlined />
                                                        </span>
                                                    </Tooltip>
                                                </div>
                                            </Radio>
                                        </div>
                                    );
                                })}
                            </div>
                        </Radio.Group>
                    </Form.Item>
                    {props?.customForm?.display?.personalLocation && (
                        <>
                            {/* ระบุตำแหน่งที่พบข้อมูลส่วนบุคคลดังกล่าว  */}
                            <div
                                className="font-semibold flex items-center space-x-3 pb-1"
                                style={{
                                    color: props?.fontStyle?.textCardColor,
                                    fontSize: props?.fontStyle?.fontSize,
                                }}
                            >
                                <div>
                                    {/* <div
                                    className="font-semibold"
                                    style={{
                                        color: props?.fontStyle
                                            ?.textCardColor,
                                        fontSize:
                                            props?.fontStyle
                                                ?.fontSize,
                                    }}
                                > */}
                                    {props.lang === 'TH'
                                        ? 'ระบุตำแหน่งที่พบข้อมูลส่วนบุคคลดังกล่าว'
                                        : 'Location where such personal data is found'}
                                    {/* </div> */}
                                    {/* <span
                                    className="ml-1.5 pb-1 text-[#ff4d4f] font-medium text-sm lead-[1px]"
                                    style={{ fontFamily: 'SimSun, sans-serif' }}
                                >
                                    *
                                </span> */}
                                </div>
                                <div>
                                    <Tooltip
                                        placement="right"
                                        overlayClassName="min-w-[30%]"
                                        title={
                                            props.lang === 'TH' ? (
                                                <>
                                                    กรณีที่เจ้าของข้อมูลพบว่าบริษัทฯ
                                                    ประมวลผลข้อมูลส่วนบุคคลของท่าน
                                                    โดยไม่ขอความยินยอม
                                                    โดยเจ้าของข้อมูลสามารถระบุแหล่งที่มา
                                                    ของข้อมูลที่พบเห็นได้ เช่น
                                                    URL , Link ภายใน Web หรือ
                                                    Application ของบริษัท
                                                </>
                                            ) : (
                                                'In case that the data owner finds that the company Process your personal data without consent The owner of the data can specify the source of the data that can be seen, such as URL, Link within the Web or the Company Application.'
                                            )
                                        }
                                    >
                                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                            <ExclamationCircleOutlined />
                                        </a>
                                    </Tooltip>
                                </div>
                            </div>
                            <Form.Item
                                // label={
                                //     <>
                                //         <div
                                //             className="font-semibold"
                                //             style={{
                                //                 color: props?.fontStyle
                                //                     ?.textCardColor,
                                //                 fontSize:
                                //                     props?.fontStyle
                                //                         ?.fontSize,
                                //             }}
                                //         >
                                //             {props.lang === 'TH'
                                //                 ? 'ระบุตำแหน่งที่พบข้อมูลส่วนบุคคลดังกล่าว'
                                //                 : 'Location where such personal data is found'}
                                //         </div>
                                //     </>
                                // }
                                // rules={[
                                //     {
                                //         required: true,
                                //         message:
                                //             props.lang === 'TH'
                                //                 ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                //                 : 'This field is required.',
                                //     },
                                // ]}
                                hidden={false}
                                name="personalLocation"
                            >
                                <TextArea
                                    size="large"
                                    autoSize={{ minRows: 5 }}
                                    placeholder={
                                        props.lang === 'TH'
                                            ? 'ระบุ URL, Link ภายใน Web หรือ Application ของบริษัท'
                                            : "Please specify URL, Link within the Company's Web or Application"
                                    }
                                />
                            </Form.Item>
                        </>
                    )}

                    {/*  */}
                    <Form.Item
                        label={
                            <div
                                className="font-semibold"
                                style={{
                                    color: props?.fontStyle?.textCardColor,
                                    fontSize: props?.fontStyle?.fontSize,
                                }}
                            >
                                {props.lang === 'TH'
                                    ? 'ระบุรายละเอียดการขอใช้สิทธิและเหตุผลในการขอ'
                                    : 'Please specify detail and reason of your request'}
                            </div>
                        }
                        rules={[
                            {
                                required: true,
                                message:
                                    props.lang === 'TH'
                                        ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                        : 'This field is required.',
                            },
                        ]}
                        hidden={false}
                        name="reason"
                    >
                        <TextArea
                            size="large"
                            autoSize={{ minRows: 5 }}
                            placeholder={
                                props.lang === 'TH'
                                    ? 'รายละเอียดอื่น'
                                    : 'Additional details'
                            }
                        />
                    </Form.Item>
                    <div className="flex space-x-4 py-4">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                            style={{
                                borderColor: props?.customStyle?.buttonColor,
                                color: props?.customStyle?.buttonColor,
                            }}
                            className="w-[120px]"
                        >
                            <ArrowLeftOutlined />{' '}
                            {props.lang === 'TH' ? 'ย้อนกลับ' : 'Previous'}
                        </Button>
                        <Button
                            style={{
                                backgroundColor:
                                    props?.customStyle?.buttonColor,
                                color: props?.fontStyle?.textButtonColor,
                                borderColor: props?.customStyle?.buttonColor,
                            }}
                            className="w-[120px]"
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                        >
                            {props.lang === 'TH' ? 'ถัดไป' : 'Next'}{' '}
                            <ArrowRightOutlined />
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
}
